import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { useSidebar } from '../../context/SidebarContext';
import { useUser } from '../../context/UserContext';
import DataSideBar, { ISidebar, usersSideBar } from './SidebarData';
import { AsideButton } from './components/AsideButton';
import { ButtonHideSidebar, Container, LinkHome } from './styles';

export const AsideMenu = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useUser();

  const [active, setActive] = useState<number | undefined>(undefined);
  const { sidebar, setSidebar } = useSidebar();
  const [sideBarData, setSideBarData] = useState<ISidebar[]>(DataSideBar);

  useEffect(() => {
    if (user?.role === 'ADMINISTRADOR') {
      const newSideBar = DataSideBar.map((item) => item);
      if (newSideBar.findIndex((side) => side.id === usersSideBar.id) === -1) {
        newSideBar.push(usersSideBar);
        setSideBarData(newSideBar);
      }
    }
  }, [user]);

  useEffect(() => {
    sideBarData.forEach((data: ISidebar, index: number) => {
      if (`/${data.path}` === pathname) {
        setActive(index);
      }
    });
  }, [pathname, sideBarData]);

  return (
    <Container showSidebar={sidebar}>
      <ButtonHideSidebar
        showSidebar={sidebar}
        onClick={() => setSidebar(!sidebar)}
        type="button"
      >
        {sidebar ? <AiOutlineArrowLeft /> : <AiOutlineArrowRight />}
      </ButtonHideSidebar>

      <LinkHome
        onClick={() => {
          setActive(undefined);
          navigate('/');
        }}
      >
        <img alt="" src="/logos/zigfrotas-logo.svg" />
      </LinkHome>

      <ul>
        {sideBarData.map((data: ISidebar, i) =>
          data.path ? (
            <Link to={data.path} key={data.id.toString()}>
              <AsideButton
                title={data.title}
                icon={data.icon}
                key={i}
                submenu={data.submenu}
                active={active === i ? 'active' : ''}
                onClick={() => setActive(i)}
              />
            </Link>
          ) : (
            <AsideButton
              key={data.id.toString()}
              title={data.title}
              icon={data.icon}
              submenu={data.submenu}
            />
          ),
        )}
      </ul>
    </Container>
  );
};
